import React, { useEffect, useState } from 'react';
import ComparisonTable from './ComparisonTable';
import Topproducts from './comparison_result/TopProducts';
import axios from "axios";
import { useComparison } from '../context/ComparisonContext';


export default function ComparisonResult() {

    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const { apiBaseUrl, addComparision } = useComparison();

    useEffect(() => {
        const models = document.getElementById("compare-model-slugs").attributes.getNamedItem('data-model-slugs').value.split(',');

        (async () => {
            setLoading(true);
            try {
                for (const model of models) {
                    const postData = {
                        type: 'ajax',
                        action: 'get-variants',
                        model: model
                    };
                    const response = await axios.post(`${apiBaseUrl}/get-variant-list`, postData);
                    const variants = response.data.data;

                    const postData2 = {
                        type: 'ajax',
                        action: 'get-model-basic-details',
                        maker: variants[0]['make'],
                        model: model
                    };

                    const response2 = await axios.post(`${apiBaseUrl}/get-variant-list`, postData2);
                    const details = response2.data.data.description;

                    const data = [
                        { variant: variants[0].variantid, model, details, variants },
                    ];
                    addComparision(data);
                }
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        })()
    }, [])

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error.message}</div>;
    }
    return (
        <div>
            <Topproducts />
            <br />
            <ComparisonTable />
        </div>
    )
}